const formatPercentage = (number = 0, decimals = 1) =>
  `${
    (Math.round((number + Number.EPSILON) * 10) / 10).toFixed(decimals) || 0
  }%`;

export default formatPercentage;
